import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { BasePopupComponent } from '../model/base-popup.model';
import { TranslateService } from '@ngx-translate/core';
import { MainMapService } from '../../../../shared/service/main-map.service';
import {Clipboard} from "@angular/cdk/clipboard";

@Component({
    selector: 'coordinates-popup',
    templateUrl: './coordinates-popup.component.html',
    styleUrls: ['./coordinates-popup.component.scss'],
    standalone: false
})
export class CoordinatesPopupComponent extends BasePopupComponent {
  @ViewChild('popupRef', { static: true }) popupRef: ElementRef;

  public xCoordinate: number;
  public yCoordinate: number;

  constructor(
    private _cdr: ChangeDetectorRef,
    private _translateService: TranslateService,
    private _mainMapService: MainMapService,
    private _clipboard: Clipboard
  ) {
    // setBaseProperties parent constructor
    super();
  }

  public init(event: any) {
    super.setBaseProperties(
      event,
      this._mainMapService.mapView,
      this.popupRef,
      false,
      this._translateService,
      false,
      'POPUP.TITEL-COORDINATES-POPUP',
      true
    );
    this.setCoordinatesValues(event);
  }

  /**
   * @function setCoordinatesValues
   * @param evt
   * @description Set coordinates values
   */
  private setCoordinatesValues(evt) {
    this.xCoordinate = Math.round(evt.mapPoint.x * 1000) / 1000;
    this.yCoordinate = Math.round(evt.mapPoint.y * 1000) / 1000;
    this._cdr.detectChanges();
  }

  /**
   * @function copyCoordinatesToClipboard
   * @description copy coordinates Easting and Northing from Popup to Clipboard
   */
  public copyCoordinatesToClipboard() {
    const textForClipboard = `${this.xCoordinate.toString()}E, ${this.yCoordinate.toString()}N`;
    this._clipboard.copy(textForClipboard);
    this._mainMapService.mapView.closePopup();
  }
}
